// Block User Modal Component
// Following existing patterns from other modals

import React, { useState } from 'react';
import {
  BlockUserModal as StyledBlockUserModal,
  BlockModalOverlay,
  BlockModalContent,
  BlockModalHeader,
  BlockModalTitle,
  BlockModalClose,
  BlockForm,
  BlockFormGroup,
  BlockLabel,
  BlockTextarea,
  BlockFormActions,
  BlockConfirmButton,
  CancelButton
} from '../../styles/Safety';

interface BlockUserModalProps {
  isOpen: boolean;
  onClose: () => void;
  onBlock: (reason?: string) => Promise<void>;
  userName?: string;
}

export const BlockUserModal: React.FC<BlockUserModalProps> = ({
  isOpen,
  onClose,
  onBlock,
  userName
}) => {
  const [reason, setReason] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    setIsSubmitting(true);
    try {
      await onBlock(reason || undefined);
      setReason('');
      onClose();
    } catch (error) {
      console.error('Error blocking user:', error);
      alert('Failed to block user. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    if (!isSubmitting) {
      setReason('');
      onClose();
    }
  };

  return (
    <StyledBlockUserModal>
      <BlockModalOverlay onClick={handleClose} />
      <BlockModalContent>
        <BlockModalHeader>
          <BlockModalTitle>
            Block {userName || 'User'}
          </BlockModalTitle>
          <BlockModalClose onClick={handleClose}>×</BlockModalClose>
        </BlockModalHeader>
        <BlockForm onSubmit={handleSubmit}>
          <p style={{ 
            marginBottom: '1rem', 
            color: '#5a6c7d',
            fontSize: '0.875rem',
            lineHeight: '1.6'
          }}>
            Blocking this user will prevent them from contacting you or seeing your profile. 
            You can unblock them later from your Safety settings.
          </p>
          
          <BlockFormGroup>
            <BlockLabel htmlFor="reason">Reason (Optional)</BlockLabel>
            <BlockTextarea
              id="reason"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Why are you blocking this user? (Optional)"
            />
          </BlockFormGroup>
          
          <BlockFormActions>
            <CancelButton type="button" onClick={handleClose} disabled={isSubmitting}>
              Cancel
            </CancelButton>
            <BlockConfirmButton type="submit" disabled={isSubmitting}>
              {isSubmitting ? 'Blocking...' : 'Block User'}
            </BlockConfirmButton>
          </BlockFormActions>
        </BlockForm>
      </BlockModalContent>
    </StyledBlockUserModal>
  );
};






